/* eslint-disable max-len */
// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class StethoscopeIcon extends PureComponent {
  
  static propTypes = {
    animSpeed: PropTypes.number,
    color: PropTypes.string,
  }
  static defaultProps = {
    animSpeed: 2000,
    color: 'black',
  }
  
  state = { active: true }
  
  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState(({ active }) => ({ active: !active }));
    }, this.props.animSpeed);
  }
  
  componentWillUnmount = () => clearInterval(this.interval)
  
  render() {
    const { animSpeed, color } = this.props;
    const { active } = this.state;
    const emitColor = color;
    
    const emitStyles = {
      opacity: active ? 1 : 0,
      transition: `opacity ${ animSpeed / 1000 }s`,
    };
    
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        height="100%"
        viewBox="0 0 272.728 216.667"
        enableBackground="new 0 0 272.728 216.667"
        xmlSpace="preserve">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={ color }
            d="M134.323,31.712c2.393,15.25,1.339,28.892,4.044,41.647
              c5.987,28.231,58.791,27.81,65.504,1.213c1.705-6.76,1.303-14.42,2.021-21.43c0.723-7.05,1.503-13.95,2.427-21.026
              c-4.366-0.332-7.35-1.013-10.514-0.405c-3.993,0.77-5.101,3.814-9.704,3.235c-8.718-1.097-9.085-15.317,0.404-16.174
              c2.854-0.258,5.493,2.559,8.491,3.235c9.554,2.157,17.022-2.09,20.217,5.661c2.113,5.126-0.866,22.039-1.617,29.112
              c-1.084,10.208-1.968,19.235-3.234,28.708c-3.214,24.021-15.903,35.192-35.986,39.222c-0.506,12.381,0.693,21.593,0,31.943
              c-1.521,22.667-16.879,40.283-35.179,47.308c-30.828,11.835-75.476-2.407-72.781-40.029c0.745-10.4,5.103-18.021,9.704-24.261
              c5.983-8.112,19.468-17.474,10.917-30.73c-9.75,0.71-16.158-5.006-16.174-12.939c-0.032-16.454,25.036-17.499,26.282-1.212
              c0.267,3.478-0.758,5.391-2.021,8.086c2.688,5.876,6.881,11.744,4.852,20.218c-2.857,11.934-15.425,18.619-20.621,29.517
              c-4.54,9.521-3.928,24.174,2.426,31.943c10.68,13.061,34.442,17.164,52.564,10.917c15.491-5.339,28.915-20.506,30.325-38.816
              c0.871-11.307-0.279-18.627,0.404-31.539c-18.188-3.49-31.756-13.696-36.391-33.56c-2.257-9.674-2.052-20.791-3.234-31.943
              c-0.485-4.57-1.019-10.054-1.617-15.77c-1.021-9.73-3.251-18.689,5.257-21.43c4.04-1.302,8.955,0.518,13.747-0.405
              c3.039-0.584,4.181-2.959,6.873-3.235c10.68-1.093,12.538,14.663,2.831,16.174c-4.458,0.694-5.603-2.401-9.3-3.235
              C142.056,30.994,139.227,32.216,134.323,31.712z M171.119,115.412c15.822-0.018,27.046-11.437,30.729-24.665
              c-2.097-0.191-3.477,2.047-5.256,3.235c-15.145,10.113-45.003,9.196-55.799-4.043c-0.248,0.022-0.479,0.06-0.404,0.404
              C144.264,104.414,156.057,115.429,171.119,115.412z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={ emitColor }
            style={ emitStyles }
            d="M108.042,110.559c-0.792-3.05-2.988-4.96-3.234-7.683
              c-0.243-2.688,1.199-4.549,1.213-6.874c0.069-11.241-8.301-18.673-16.578-19.813c-27.683-3.811-31.533,38.01-4.448,40.03
              c0.083,2.238,0.057,4.369-0.809,5.661c-30.686-0.063-32.235-48.389-2.426-52.16C105.328,66.739,119.482,90.415,108.042,110.559z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StethoscopeIcon/index.jsx